module.exports = __webpack_public_path__ + "static/img/10.bf9332f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/10.png
// module id = z03r
// module chunks = 4